import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import Notification from './Notification';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [showNotification, setShowNotification] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    setShowNotification(true);
    setFormData({ name: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8" itemScope itemType="https://schema.org/ContactPage">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-toxic-green to-toxic-cyan bg-clip-text text-transparent" itemProp="name">
              Contactez-nous
            </span>
          </h2>
          <p className="text-xl text-white/70" itemProp="description">
            Une question ? Une suggestion ? Nous sommes là pour vous aider.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="glass-strong rounded-2xl p-8 border border-toxic-green/30" itemScope itemType="https://schema.org/Organization">
            <h3 className="text-2xl font-bold text-white mb-6">Informations de contact</h3>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4" itemProp="contactPoint" itemScope itemType="https://schema.org/ContactPoint">
                <div className="w-12 h-12 glass rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-toxic-green" />
                </div>
                <div>
                  <h4 className="font-semibold text-white mb-1">Email</h4>
                  <a href="mailto:info@rougebets.com" className="text-toxic-green hover:text-toxic-cyan transition-colors" itemProp="email">
                    info@rougebets.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" itemProp="contactPoint" itemScope itemType="https://schema.org/ContactPoint">
                <div className="w-12 h-12 glass rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-toxic-green" />
                </div>
                <div>
                  <h4 className="font-semibold text-white mb-1">Téléphone</h4>
                  <a href="tel:+33742963066" className="text-toxic-green hover:text-toxic-cyan transition-colors" itemProp="telephone">
                    +33 7 42 96 30 66
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                <div className="w-12 h-12 glass rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-toxic-green" />
                </div>
                <div>
                  <h4 className="font-semibold text-white mb-1">Adresse</h4>
                  <p className="text-white/80" itemProp="addressLocality">Paris</p>
                  <p className="text-white/80" itemProp="addressCountry">France</p>
                </div>
              </div>
            </div>
          </div>

          <div className="glass-strong rounded-2xl p-8 border border-toxic-cyan/30">
            <h3 className="text-2xl font-bold text-white mb-6">Envoyez-nous un message</h3>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-white mb-2">
                  Nom
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  autoComplete="name"
                  className="w-full px-4 py-3 glass border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-toxic-green transition-colors"
                  placeholder="Votre nom"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-white mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  autoComplete="email"
                  className="w-full px-4 py-3 glass border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-toxic-green transition-colors"
                  placeholder="votre@email.com"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-white mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  autoComplete="off"
                  className="w-full px-4 py-3 glass border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-toxic-green transition-colors resize-none"
                  placeholder="Votre message..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full px-6 py-3 bg-gradient-to-r from-toxic-green to-toxic-cyan text-black font-bold rounded-lg hover:shadow-lg hover:shadow-toxic-green/50 transition-all flex items-center justify-center gap-2"
              >
                <Send className="w-5 h-5" />
                Envoyer le message
              </button>
            </form>
          </div>
        </div>
      </div>
      <Notification
        message="Merci pour votre message ! Nous vous répondrons dans les plus brefs délais."
        isVisible={showNotification}
        onClose={() => setShowNotification(false)}
      />
    </section>
  );
};

export default Contact;

